<template>
  <div>
    <a class="button full-width-button is-primary" @click="openManageOfferModal">
        <span class="icon is-small">
            <i class="fas fa-plus"></i>
        </span>
        <span>Add</span>
    </a>
    <p v-if="isLoading">Loading offers...</p>
    <div class="columns mt-1 is-multiline" v-if="!isLoading">
        <div class="column is-4" v-for="offer in offers" :key="offer.docId">
            <div class="card">
                <div class="card-content">
                    <p>{{offer.label}}</p>
                </div>
                <footer class="card-footer">
                    <a class="card-footer-item" @click="deleteOffer(offer)">Delete</a>
                    <a class="card-footer-item" @click="openManageOfferModal(offer)">Edit</a>                    
                </footer>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import OffersService from './service';
import ManageOffer from './ManageOffer';

export default {
  name: 'offers',

  props: ['city'],

  created() {
    this.fetchOffers();
  },

  components: {
    ManageOffer
  },

  data() {
    return {
      isLoading: true,
      offers: null,
      files: null
    };
  },

  methods: {
    fetchOffers() {
      OffersService.all(this.city.docId).then(data => {
        this.offers = data;
        this.isLoading = false;
      });
    },

    openManageOfferModal(offer = null) {
      this.$modal.open({
        parent: this,
        props: {
          propOffer: offer,
          city: this.city
        },
        component: ManageOffer,
        hasModalCard: true
      });
    },

    deleteOffer(offerToDelete) {
      this.isLoading = true;

      OffersService.deleteOffer(this.city.docId, offerToDelete.docId).then(
        () => {
          this.isLoading = false;
          this.$toast.open('Operation successfull');
          this.offers = this.offers.filter(
            offer => offer.docId !== offerToDelete.docId
          );
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Offers/Offers.vue